import makeStyles from '@mui/styles/makeStyles';
import colors from '../../styles/colors';

export const useStyles = makeStyles({
  link: {
    display: 'inline',
    textDecoration: 'none !important',
    color: colors.blue.l45,
    '&:hover': {
      textDecoration: 'underline !important',
    },
  },
});
